import { ServiceRequestCreateScreen } from '@/modules/support';
import React from 'react';

export default function ServiceRequestCreate() {
    return <ServiceRequestCreateScreen />;
}


